module.exports = __webpack_public_path__ + "static/media/110-sound.8b916a45.svg";